import * as React from 'react'
import { Alert } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Label } from '@/components/ui/label'
import type { InvoiceResponse } from '@/pages/InvoicesPage.types'

export interface VoidInvoiceResponse extends InvoiceResponse {
  void_confirmation: {
    refunded: string
    refunded_cents: number
    returned_to_account_credit: string
    returned_to_account_credit_cents: number
    message: string | null
  }
}

export function VoidInvoiceDialog({
  pending,
  error,
  onClose,
  onSubmit,
}: {
  pending: boolean
  error: boolean
  onClose: () => void
  onSubmit: (refundToPayer: boolean) => void
}) {
  const [refundToPayer, setRefundToPayer] = React.useState(true)

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Void invoice</DialogTitle>
          <DialogDescription className="sr-only">Void invoice options</DialogDescription>
        </DialogHeader>
        <div className="flex items-start gap-2">
          <Checkbox
            id="refund-to-payer"
            aria-label="Refund payments to payer"
            checked={refundToPayer}
            onCheckedChange={(checked) => setRefundToPayer(checked === true)}
          />
          <Label htmlFor="refund-to-payer">Refund payments to payer</Label>
        </div>
        {error && <Alert>Invoice could not be voided</Alert>}
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose} disabled={pending}>
            Keep Invoice
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={() => onSubmit(refundToPayer)}
            disabled={pending}
          >
            Void Invoice
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
